module.exports = __webpack_public_path__ + "static/media/hamburger_icon.f97a60b9.svg";